export const SPREEDLY_ERROR = 'SpreedlyError';
export const TIMEKIT_BOOKING_ERROR_MESSAGE = 'Failed to create a booking on Timekit';

/**
 * `errorCode` values raised by visitor registration when a booking also creates visitors.
 * They arrive on `SerializableError.response.errorCode`, not on `key` — visitor registration
 * sends a plain-string `message` plus a separate top-level `errorCode`. See RES-1011.
 */
export enum VisitorRegistrationErrorsEnum {
  /** The visitor's email or phone number already belongs to another profile. */
  DUPLICATE_PROFILE = 'DUPLICATE_PROFILE',
}

/**
 * helix rejects a booking whose people (booker + guests) exceed the resource's capacity with a
 * 422 and a plain-string message, e.g. "Booking will exceed maximum capacity for resource <uuid>".
 * It carries no `key` or `errorCode`, so the message text is the only discriminator. See RES-1423.
 */
export const CAPACITY_EXCEEDED_ERROR_MESSAGE = 'exceed maximum capacity';

/**
 * Fragments of the messages helix answers with when the chosen slot was taken after it was offered:
 * Exchange ("Timeslot for <room> is not available"), the native adapter ("Booking is not available
 * for resource ...") and the generic "... already booked ...". Newer helix builds also send the key
 * `BOOKING_UNAVAILABLE_ERROR`; the text keeps older builds readable. See ECHO-134.
 */
export const BOOKING_UNAVAILABLE_ERROR_MESSAGES = ['is not available', 'already booked'];
